import React, { Component } from "react";
import { assetUrl } from '../../config';

import { Link } from "react-router-dom";
import $ from 'jquery';
import CollectionMasonry from "../CollectionMasonry";
import { loadScripts } from '../../loadScript';
import { withT } from '../../i18n';

import CollectionHeroImage from '../../assets/images/kanosei/collection_hero_image.png'



class Collection extends Component {
  constructor() {
    super();
    this.loadJs = this.loadJs.bind(this);


    this.state = {
      slider: [
        {
          title: 'prifma.luminosos',
          description: 'GMUNK',
          img: assetUrl('home/PrifmaHome-poster.jpg'),
          video: assetUrl('home/PrifmaHome.mp4'),
          href: `prifma-luminosos`,
        },
        {
          title: 'The Last Shawarma',
          description: 'Bosslogic',
          img: assetUrl('home/TheLastShawarma-poster.jpg'),
          video: assetUrl('home/TheLastShawarma.mp4'),
          href: `the-last-shawarma`,
        },
        {
          title: 'GOAT',
          description: 'Beeple & Corridor Studio',
          img: assetUrl('home/Goat.jpg'),
          href: `goat`,
        },
        {
          title: 'Eardley',
          description: 'Trevor Jones',
          img: assetUrl('home/Eardley.jpg'),
          href: `eardley`,
        },
        {
          title: 'Rain Village',
          description: 'SeerLight',
          img: assetUrl('home/RainVillage.jpg'),
          video: assetUrl('home/RainVillage.mp4'),
          href: `rain-village`,
        },
        {
          title: 'An Electric Storm',
          description: 'Reuben Wu',
          img: assetUrl('home/ElectricStorm-poster.jpg'),
          video: assetUrl('home/ElectricStorm.mp4'),
          href: `an-electric-storm`,
        },
        {
          title: 'Universe Edge',
          description: 'Six n Five',
          img: assetUrl('home/UniverseEdge.jpg'),
          href: `universe-edge`,
        },
        {
          title: 'Skateboard Rides You',
          description: 'Deekaymotion',
          img: assetUrl('home/SkateboardRidesYou.jpg'),
          video: assetUrl('home/SkateboardRidesYou.mp4'),
          href: `skateboard-rides-you`,
        },
        {
          title: 'Seasons',
          description: 'Blake Kathryn',
          img: assetUrl('collection/topslide/Seasons.jpg'),
          video: assetUrl('collection/topslide/Seasons.mp4'),
          href: `seasons`,

        },
        {
          title: 'The Raven',
          description: 'Vini Naso',
          img: assetUrl('collection/topslide/The-Raven.jpeg'),
          href: `the-raven`,
        },
        {
          title: 'Visual Meditation',
          description: 'Reisinger Andres',
          img: assetUrl('collection/topslide/Visual-Meditation.jpg'),
          video: assetUrl('collection/topslide/Visual-Meditation.mp4'),
          href: `visual-meditation`,
        },
        {
          title: 'The Martian',
          description: 'Fabio Giampetrio',
          img: assetUrl('collection/topslide/Martian.jpeg'),
          href: `the-martian`,
        },
        {
          title: 'SpaceStation',
          description: 'Filip Hodas',
          img: assetUrl('collection/topslide/SpaceStation.jpg'),
          video: assetUrl('collection/topslide/SpaceStation.mp4'),
          href: `spaceStation`,

        },
        {
          title: 'Hyperreality',
          description: 'Nessgraphics',
          img: assetUrl('collection/topslide/Hyperreality.jpg'),
          video: assetUrl('collection/topslide/Hyperreality.mp4'),
          href: `hyperreality`,

        },
        {
          title: 'The Universe Machine',
          description: 'Joshua Davis',
          img: assetUrl('collection/topslide/the-Universe-Machine.jpg'),
          video: assetUrl('collection/topslide/the-Universe-Machine.mp4'),
          href: `the-universe-machine`,

        },
        {
          title: 'Daughter',
          description: 'Adam Swaab',
          img: assetUrl('collection/topslide/Daughter.jpg'),
          video: assetUrl('collection/topslide/Daughter.mp4'),
          href: `daughter`,

        },
        {
          title: 'Down the Rabbit Hole',
          description: 'Andreas Wannerstedt',
          img: assetUrl('collection/topslide/Down-the-Rabbit-Hole.jpg'),
          video: assetUrl('collection/topslide/Down-the-Rabbit-Hole.mp4'),
          href: `down-the-rabbit-hole`,

        }, {
          title: 'Wavestep',
          description: 'Neurocolor',
          img: assetUrl('collection/topslide/Wavestep.jpg'),
          video: assetUrl('collection/topslide/Wavestep.mp4'),
          href: `wavestep`,

        },
        {
          title: 'There can only be one',
          description: 'Gavin Shapiro',
          img: assetUrl('collection/topslide/There-can-only-be-one.jpg'),
          video: assetUrl('collection/topslide/There-can-only-be-one.mp4'),
          href: `there-can-only-be-one`,

        },
        {
          title: 'The Drop',
          description: 'Alessio DeVecchi',
          img: assetUrl('collection/topslide/The-Drop.jpg'),
          video: assetUrl('collection/topslide/The-Drop.mp4'),
          href: `the-drop`,

        },
        {
          title: 'Excalibur',
          description: 'Mattey',
          img: assetUrl('collection/topslide/Excalibur.jpg'),
          video: assetUrl('collection/topslide/Excalibur.mp4'),
          href: `excalibur`,

        },
        {
          title: 'The Psychotropic Colony',
          description: 'GMUNK',
          img: assetUrl('collection/topslide/The-Psychotropic-Colony.jpg'),
          video: assetUrl('collection/topslide/The-Psychotropic-Colony.mp4'),
          href: `the-psychotropic-colony`,

        },
      ]
    }
  }




  loadJs() {

    $.fn.jQuerySimpleCounter = function (options) {
      var settings = $.extend({
        start: 0,
        end: 100,
        easing: 'swing',
        duration: 400,
        complete: ''
      }, options);

      var thisElement = $(this);

      $({ count: settings.start }).animate({ count: settings.end }, {
        duration: settings.duration,
        easing: settings.easing,
        step: function () {
          var mathCount = Math.ceil(this.count);
          thisElement.text(mathCount);
        },
        complete: settings.complete
      });
    };


    $('#number1').jQuerySimpleCounter({ end: 170, duration: 3000 });
    $('#number2').jQuerySimpleCounter({ end: 1000, duration: 3000 });

    /*  $('.grid').masonry({
         itemSelector: '.grid-item'
     }); */


    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        $(".custom-lightbox").each(function () {
          if ($(this).hasClass('showlight')) {
            var close_light = $(this).find('.close_light');
            close_light.trigger('click');
          }
        });
      }
    });


    /* $("html body").on('click','.custom-lightbox',function(e){

        
        
    }); */

    $("html body").on('click', '.close_light', function (e) {
      e.stopPropagation();
      var thispar = $(this).closest(".custom-lightbox");
      thispar.removeClass('showlight');
      var vid = thispar.find('video');
      if (vid.length > 0) {
        var jsvid = vid.get(0);

        if (jsvid.paused) {
        } else {
          vid[0].pause();
        }

      }

    });


    $("html body").on('click', '.next_pop', function (e) {
      e.stopPropagation();
      var custom_lightbox = $(".showlight");
      if (custom_lightbox.length > 0) {
        var this_grid_item = $(this).closest('.grid-item');
        var thisindex = $(".grid-item").index(this_grid_item);
        var next_index = thisindex + 1;
        var next_item = $(".grid-item").eq(next_index);
        if (next_item.length == 0) {
          next_index = 0;
          next_item = $(".grid-item").eq(next_index);
        }

        var pre_close = this_grid_item.find('.close_light');
        pre_close.trigger('click');

        var next_click = next_item.find('.click_surface');
        next_click.trigger('click');
      }
    });

    $("html body").on('click', '.pre_pop', function (e) {
      e.stopPropagation();
      var custom_lightbox = $(".showlight");
      if (custom_lightbox.length > 0) {
        var this_grid_item = $(this).closest('.grid-item');
        var thisindex = $(".grid-item").index(this_grid_item);
        pre_index = thisindex - 1;
        if (thisindex == 0) {
          var pre_index = ($(".grid-item").length) - 1;
        }

        var pre_item = $(".grid-item").eq(pre_index);
        var this_close = this_grid_item.find('.close_light');
        this_close.trigger('click');

        var pre_click = pre_item.find('.click_surface');
        pre_click.trigger('click');
      }
    });
  }
  clickMenu() {
    $("#page-loader").show();
    window.scrollTo(0, 0);
    setTimeout(function () { $("#page-loader").fadeOut(1500); }, 3000);
    $(".qodef-follow-info-holder").remove();
  }

  componentDidMount() {
    this.loadJs()

    // The carousel config used to live appended to the bottom of
    // swiper-bundle.min.js, past the vendor sourcemap comment, wrapped in
    // $(document).ready(). Two problems with that: any Swiper upgrade silently
    // discarded it, and because a cached <script> does not re-execute, the
    // carousel stayed dead after navigating away and back. React owns it now.
    loadScripts(['/assets/js/swiper-bundle.min.js', '/assets/js/amoli-core2.js'])
      .then(() => this.initSwiper())
      .catch((err) => console.error('[collection] legacy scripts failed:', err))
  }

  // Play the artwork that is centred, pause everything else.
  //
  // Driven off the DOM rather than React state on purpose: Swiper's loop mode
  // clones slide elements, and React knows nothing about the clones. Querying
  // live slides covers the originals and the duplicates alike, and
  // .swiper-slide-active is exactly the centred one under centeredSlides.
  syncSlideVideos = () => {
    const slides = document.querySelectorAll('.collection__slider .swiper-slide')
    slides.forEach((slide) => {
      const video = slide.querySelector('video')
      if (!video) return

      if (slide.classList.contains('swiper-slide-active')) {
        // React renders `muted` as a property but not the attribute, and
        // Chrome's autoplay policy reads the attribute. See AutoVideo.
        video.muted = true
        video.setAttribute('muted', '')
        const attempt = video.play()
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {})
      } else if (!video.paused) {
        video.pause()
        video.currentTime = 0
      }
    })
  }

  initSwiper() {
    if (!window.Swiper || this.swiper) return
    const el = document.querySelector('.collection__slider')
    if (!el) return

    this.swiper = new window.Swiper(el, {
      on: {
        init: this.syncSlideVideos,
        slideChangeTransitionEnd: this.syncSlideVideos,
        // loop mode swaps in duplicate slides without a transition end
        loopFix: this.syncSlideVideos,
      },
      loop: true,
      centeredSlides: true,
      // Wheel events must reach the document. With mousewheel enabled Swiper
      // swallows them and converts each into a slide change, so the page will
      // not scroll while the cursor is over the artwork strip.
      mousewheel: false,
      // 8s rather than 5s. Each centred slide streams its artwork (12 videos,
      // 244 MB, averaging 20 MB), so the rotation rate directly sets how much
      // a visitor idling on this section pulls down. Re-encoding was measured
      // and rejected: the files are already faststart at a sensible bitrate,
      // and a native-resolution re-encode saves ~0% — only downscaling helps,
      // and the same file also feeds the larger artwork pages.
      autoplay: { delay: 8000, disableOnInteraction: true },
      // Arrow keys navigate the carousel; PageUp/PageDown must keep paging the
      // document rather than jumping slides.
      keyboard: { enabled: true, pageUpDown: false },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 10 },
        1024: { slidesPerView: 5, spaceBetween: 10 },
      },
    })
  }

  componentWillUnmount() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }

  /* ShowPop(event){
      console.log(event.target);
  } */


  render() {
    const { t } = this.props;
    return (
      <>
        <div className="collection__slider_main">
          <div className="wrapper">
            <div className="swiper mySwiper collection__slider">
              <div className="swiper-wrapper">
                {
                  this.state.slider.map((value, index) => {
                    return <div className="swiper-slide">
                      <Link onClick={() => this.clickMenu()} to={`/portfolio-item/${value.href}`} className="slide__img">
                        <img src={value.img} alt={t('collection.alt', { title: value.title, artist: value.description })} />
                        {/* preload="none" is load-bearing: these are the full
                            artworks (12 files, 244 MB, averaging 20 MB) and the
                            carousel holds 14 slides. Nothing is fetched until
                            syncSlideVideos calls play() on the centred slide. */}
                        {value.video && (
                          <video
                            className="slide__video"
                            src={value.video}
                            poster={value.img}
                            muted
                            loop
                            playsInline
                            preload="none"
                            aria-hidden="true"
                          />
                        )}
                      </Link>
                      <div className="slide__content">
                        <h5 className="title">{value.title}</h5>
                        <p className="desc">{value.description}</p>
                      </div>
                    </div>
                  })
                }
              </div>
            </div>

            <div className="swiper-button-prev">
              <span className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve"><g><polygon fill="#BABABA" points="19.178,25.979 19.982,25.388 12.633,15.378 19.982,5.37 19.178,4.778 11.393,15.378"></polygon></g></svg>
              </span>

            </div>
            <div className="swiper-button-next">
              <span className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve"><g><polygon fill="#BABABA" points="12.198,25.979 11.392,25.388 18.742,15.378 11.392,5.37 12.198,4.778 19.982,15.378"></polygon></g></svg>
              </span>

            </div>
          </div>
        </div>


        <div className="counter__div">
          <div className="wrapper">
            <div className="counter_main">
              <div className="counter__box">
                <div className="number number1"><span id="number1"></span><span>+</span></div>
                <span className="text">{t('collection.artistsCounted')}</span>
              </div>
              <div className="counter__box">
                <div className="number number2"><span id="number2"></span><span>+</span></div>
                <span className="text">{t('collection.worksCounted')}</span>
              </div>
            </div>
          </div>
        </div>

        <section className="about__main collection_page">
          <div className="about_header">
            <div className="left__panel">
              <h2 className="heading styled">{t('collection.heading')}</h2>
              <div className="desc">
                <p>{t('collection.p1')}</p>
                <p>{t('collection.p2')}</p>
                <p>{t('collection.p3')}</p>
                <p>{t('collection.p4')}</p>
                <p>{t('collection.p5')}</p>
              </div>
              {/* The curators' names and handles are people, not copy. Only
                  "Curated by" and the connector are translated. */}
              <h4 className="small_heading styled">{t('collection.curatedBy')} Matt <a href="https://twitter.com/y_kymin" target="_blank" rel="noreferrer">(@y_kymin)</a> {t('collection.and')} Tom <a href="https://twitter.com/think_flexible" target="_blank" rel="noreferrer">(@think_flexible)</a></h4>
            </div>
            <div className="right__panel">
              <img src={CollectionHeroImage} alt="" />
            </div>
          </div>
        </section>

        <CollectionMasonry />
      </>
    )
  }
}

export default withT(Collection);